import React from 'react';
import { InfoCardWidget } from '../../../../statisticsWidgets/statisticsWidgets';

export default ({ data, loading, title, children, comment }) => {
  return <InfoCardWidget primaryColor="#4cd964" secondaryColor="#595959" icon="icon-plant"
                         title={title} data={data} loading={loading} comment={comment}>
    {children}
  </InfoCardWidget>
};



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/widgets/pointsEarned.js